/* Shared quick-add helper — works on any page that renders .product-card
   markup with a .product-card__quick-add button inside.

   Parses the card's DOM for handle / title / image / price (+ compare-at),
   pushes it into TPHCart, flashes the button, and pops the drawer. */
(() => {
  function handleQuickAdd(btn) {
    if (!window.TPHCart) return;
    // Read variant id from the button (set by Liquid render or by a swatch click).
    const variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;

    window.TPHCart.add({ id: Number(variantId), quantity: 1 }).then(() => {
      flashQuickAdd(btn);
      document.dispatchEvent(new CustomEvent('cart:open'));
    });
  }

  function flashQuickAdd(btn) {
    if (btn._reverting) return;
    const original = btn.innerHTML;
    btn._reverting = true;
    btn.classList.add('product-card__quick-add--added');
    btn.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12l5 5L20 7"/></svg>';
    setTimeout(() => {
      btn.classList.remove('product-card__quick-add--added');
      btn.innerHTML = original;
      btn._reverting = false;
    }, 1100);
  }

  // Event-delegation: catch clicks anywhere, swallow the overlay link click,
  // and trigger the add. This auto-wires dynamically rendered cards too.
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.product-card__quick-add');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    handleQuickAdd(btn);
  });

  window.handleQuickAdd = handleQuickAdd;
})();
